import React, { useState } from "react";
import { MapContainer, TileLayer, GeoJSON } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import countriesData from "./countries.json";

const ComplianceMap = () => {
  const [content, setContent] = useState("");

  const onEachCountry = (country, layer) => {
    const countryName = country.properties.ADMIN;

    // Setze die Standardfarbe (hellgrau) und übergehe nur für Länder mit besonderer Regulierung
    const fillColor = getColorForCountry(countryName) || "#d3d3d3"; // Hellgrau für Länder ohne besondere Regulierung
    layer.setStyle({
      fillColor: fillColor,
      fillOpacity: 1,
      color: "black",
      weight: 1,
      dashArray: "3",
    });

    // Event für Klick, um den Inhalt anzuzeigen
    layer.on({
      click: () => {
        setContent(
          getContentForCountry(countryName) ||
            "Keine spezifischen Informationen verfügbar"
        );
      },
      mouseover: (e) => {
        const layer = e.target;
        layer.setStyle({
          fillColor: "blue",
        });
      },
      mouseout: (e) => {
        const layer = e.target;
        layer.setStyle({
          fillColor: fillColor,
        });
      },
    });
  };

  const getColorForCountry = (countryName) => {
    switch (countryName) {
      case "Germany":
      case "France":
      case "Italy":
      case "Spain":
      case "European Union":
      case "United Kingdom":
      case "Belgium":
      case "Austria":
        return "#b9266b"; // Sehr strenge Regulierung
      case "United States of America":
      case "Brazil":
      case "Japan":
      case "South Korea":
      case "Russia":
      case "China":
      case "Israel":
        return "#ff4d4d"; // Strenge Regulierung
      case "Canada":
      case "Australia":
      case "India":
      case "South Africa":
      case "Netherlands":
      case "Sweden":
      case "Poland":
      case "New Zealand":
        return "#ff7f7f"; // Erhöhte Regulierung
      case "Mexico":
      case "Argentina":
      case "Indonesia":
      case "Switzerland":
      case "Norway":
      case "Denmark":
      case "Finland":
      case "Chile":
      case "Malaysia":
        return "#ffbf7f"; // Moderate Regulierung
      default:
        return null; // Keine besondere Regulierung
    }
  };

  const getContentForCountry = (countryName) => {
    switch (countryName) {
      case "Germany":
        return "Hauptregularien in Deutschland: DSGVO, BDSG (Bundesdatenschutzgesetz)";
      case "France":
        return "Hauptregularien in Frankreich: DSGVO, Loi Informatique et Libertés";
      case "Italy":
        return "Hauptregularien in Italien: DSGVO, Codice in materia di protezione dei dati personali";
      case "Spain":
        return "Hauptregularien in Spanien: DSGVO, Ley Orgánica de Protección de Datos Personales y garantía de los derechos digitales (LOPDGDD)";
      case "United States of America":
        return "Hauptregularien in den USA: HIPAA, CCPA, GLBA, COPPA";
      case "Canada":
        return "Hauptregularien in Kanada: PIPEDA, PIPA, PHIPA";

      case "Brazil":
        return "Hauptregularien in Brasilien: LGPD";
      case "European Union":
        return "Hauptregularien in der EU: DSGVO, ePrivacy-Richtlinie, NIS-Richtlinie";
      case "United Kingdom":
        return "Hauptregularien im Vereinigten Königreich: UK GDPR, DPA 2018, PECR";
      case "China":
        return "Hauptregularien in China: Cybersecurity Law, Data Security Law";
      case "Israel":
        return "Hauptregularien in Israel: Protection of Privacy Law, Data Security Regulations";
      case "Australia":
        return "Hauptregularien in Australien: Privacy Act, NDB Scheme, Spam Act, DNCR Act";
      case "Japan":
        return "Hauptregularien in Japan: APPI";
      case "South Korea":
        return "Hauptregularien in Südkorea: PIPA, Network Act, Location Info Act";
      case "India":
        return "Hauptregularien in Indien: IT Act, SPDI Rules";
      case "South Africa":
        return "Hauptregularien in Südafrika: POPIA";
      case "New Zealand":
        return "Hauptregularien in Neuseeland: Privacy Act 2020";
      case "Chile":
        return "Hauptregularien in Chile: Protección de la Vida Privada (Ley 19.628)";
      case "Malaysia":
        return "Hauptregularien in Malaysia: PDPA (Personal Data Protection Act)";
      case "Mexico":
        return "Hauptregularien in Mexiko: LFPDPPP, LGPDPPSO";
      case "Argentina":
        return "Hauptregularien in Argentinien: PDPL";
      case "Indonesia":
        return "Hauptregularien in Indonesien: PDP Law";
      case "Russia":
        return "Hauptregularien in Russland: Föderales Gesetz Nr. 152-FZ, Arbeitsgesetzbuch";
      case "Netherlands":
        return "Hauptregularien in den Niederlanden: DSGVO, Uitvoeringswet AVG";
      case "Sweden":
        return "Hauptregularien in Schweden: DSGVO, Lag om kompletterande bestämmelser till EU:s dataskyddsförordning";
      case "Poland":
        return "Hauptregularien in Polen: DSGVO, Ustawa o ochronie danych osobowych";
      case "Switzerland":
        return "Hauptregularien in der Schweiz: DSG, VDSG";
      case "Norway":
        return "Hauptregularien in Norwegen: DSGVO (als EWR-Mitglied), Lov om behandling av personopplysninger";
      case "Denmark":
        return "Hauptregularien in Dänemark: DSGVO, Databeskyttelsesloven";
      case "Finland":
        return "Hauptregularien in Finnland: DSGVO, Tietosuojalaki";

      default:
        return null;
    }
  };

  return (
    <div>
      <MapContainer
        center={[30, 0]}
        zoom={2}
        style={{ height: "600px", width: "100%" }}
      >
        <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
        <GeoJSON data={countriesData} onEachFeature={onEachCountry} />
      </MapContainer>
      <div className="compliance-text">{content}</div>
      <div>
        <div className="compliance-text">
          {/* Legende */}
          <div className="pt-3">
            <span
              style={{
                backgroundColor: "#b9266b",
                display: "inline-block",
                width: "15px",
                height: "15px",
                marginRight: "5px",
              }}
            ></span>
            Sehr strenge Regulierung (z. B. DSGVO, GDPR)
          </div>
          <div>
            <span
              style={{
                backgroundColor: "#ff4d4d",
                display: "inline-block",
                width: "15px",
                height: "15px",
                marginRight: "5px",
              }}
            ></span>
            Strenge Regulierung
          </div>
          <div>
            <span
              style={{
                backgroundColor: "#ff7f7f",
                display: "inline-block",
                width: "15px",
                height: "15px",
                marginRight: "5px",
              }}
            ></span>
            Erhöhte Regulierung
          </div>
          <div>
            <span
              style={{
                backgroundColor: "#ffbf7f",
                display: "inline-block",
                width: "15px",
                height: "15px",
                marginRight: "5px",
              }}
            ></span>
            Moderate Regulierung
          </div>
          <div>
            <span
              style={{
                backgroundColor: "#d3d3d3",
                display: "inline-block",
                width: "15px",
                height: "15px",
                marginRight: "5px",
              }}
            ></span>
            Keine besonderen Regulierungen / Keine Daten
          </div>
        </div>
      </div>
    </div>
  );
};

export default ComplianceMap;
